<footer class="sp-footer">
  <div class="container">
    <div class="row">
      <div class="col-md-5 col-sm-6 copyrights">
        Copyright {{year}} SmartProperty | All Rights Reserved | <a [routerLink]="['/privacy']">Privacy</a> | <a [routerLink]="['/terms']">Terms</a>
      </div>
      <div class="col-md-4 offset-md-3 col-lg-4 col-lg-offset-3 social">
        <label>Find us online:</label>
        <ul class="links-list">
          <li><a><i class="sp-icon-sm-facebook"></i></a></li>
          <li><a><i class="sp-icon-sm-twitter"></i></a></li>
          <li><a><i class="sp-icon-sm-instagram"></i></a></li>
          <li><a><i class="sp-icon-sm-google"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
